module.exports = __webpack_public_path__ + "img/51.6b843b22.svg";